import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { WeavyPaywallEntrypointKey } from '@/consts/weavyPaywallEntrypoints.consts';

interface WeavyPaywallState {
  activeEntrypoint: WeavyPaywallEntrypointKey | null;
  closePaywall: () => void;
  openPaywall: (entrypoint: WeavyPaywallEntrypointKey) => void;
}

/** Controls which registry-backed Weavy paywall is currently open. */
export const useWeavyPaywallStore = create<WeavyPaywallState>()(
  devtools(
    (set) => ({
      activeEntrypoint: null,
      closePaywall: () => set({ activeEntrypoint: null }),
      openPaywall: (entrypoint) => set({ activeEntrypoint: entrypoint }),
    }),
    {
      name: 'Weavy Paywall Store',
      enabled: import.meta.env.DEV,
    },
  ),
);
